export default "__VITE_ASSET__DqyH$A6C__"